import React, { useContext, useState, createContext } from 'react';
import { AttachmentsDownloadStore } from './attachments-download-store';

const AttachmentsDownloadStoreContext = createContext<AttachmentsDownloadStore | undefined>(
    undefined
);

export function AttachmentsDownloadStoreProvider({ children }: { children: React.ReactNode }) {
    const [store] = useState(() => new AttachmentsDownloadStore());

    return (
        <AttachmentsDownloadStoreContext.Provider value={store}>
            {children}
        </AttachmentsDownloadStoreContext.Provider>
    );
}

export function useAttachmentsDownloadStore(): AttachmentsDownloadStore {
    const store = useContext(AttachmentsDownloadStoreContext);
    if (!store) {
        throw new Error('Unexpectedly did not find attachments download store');
    }
    return store;
}
